var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex align-items-center justify-content-center",staticStyle:{"min-height":"600px"}},[_c('img',{staticClass:"img-margin",staticStyle:{"max-height":"500px","max-width":"450px"},attrs:{"src":_vm.imageLink}})])
}
var staticRenderFns = []

export { render, staticRenderFns }